import { render, staticRenderFns } from "./goodsManagementDetail.vue?vue&type=template&id=75c28fc8&scoped=true"
import script from "./goodsManagementDetail.vue?vue&type=script&lang=js"
export * from "./goodsManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./goodsManagementDetail.vue?vue&type=style&index=0&id=75c28fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c28fc8",
  null
  
)

export default component.exports